import $ from 'jquery';
import MenuWidget from '../../components/menu-widget';
import ProductColorSelect from '../../components/product-color-select';
import RevealWhenVisible from '../../components/reveal-when-visible';
import BannerSlider from './components/banner-slider';
import InfiniteScroll from './components/infinite-scroll';
import LazyImages from '../../components/lazy-images';
import InlineVideo from '../../components/inline-video';
import ResponsiveVideo from '../../components/responsive-video';
import ModalVideoWithParameters from '../../components/modal-video-with-parameters';
import ReorderElements from './components/reorder-elements';
$(() => {
    MenuWidget.init();
    ProductColorSelect.init();
    RevealWhenVisible.init();
    BannerSlider.init();
    InfiniteScroll.init($('body'), () => {
        ProductColorSelect.init();
        RevealWhenVisible.init();
        LazyImages.init();
    });
    InlineVideo.init();
    ResponsiveVideo.init();
    ModalVideoWithParameters.init();
    ReorderElements.init();
});
